import { OrderSource } from '@/view-models/order'
import { getOrderSource } from '@/service/order'

export const bookingEngineSubdomains = ref(['woorao', 'wooyuu', 'immersion', 'slowlysunset', 'daovillalake', 'chanshuoforestville', 'chilllifestyle'])

/**
 * check if host is booking engine subdomain
 * @param {string} host
 * @returns {boolean}
 */
export function checkBookingEngineSubdomainHost(host) {
  const config = useRuntimeConfig()
  const envSubdomain = config.public.BOOKING_ENGINE_DOMAIN
  const tenantName = (!host.startsWith('www') && host.includes(envSubdomain) && host.split(envSubdomain)[0]) || ''

  return bookingEngineSubdomains.value.includes(tenantName)
}

export const useBookingEngineData = (subdomainQueryString = '', store) => {
  const config = useRuntimeConfig()
  const subdomainQS = isRef(subdomainQueryString) ? subdomainQueryString : ref(subdomainQueryString)
  // FIXME: call API for booking engine data
  /** @type {{ subdomain: string, branchId: string, logoImage: string }[]}>} */
  const bookingEngineDataMap = reactive([
    // 霧繞
    {
      subdomain: 'woorao',
      branchId: config.public.BOOKING_ENGINE_BRANCH_ID_WOORAO,
      logoImage: useAsset('@/assets/images/logo/logo_woorao.png'),
      headerLogoImage: useAsset('@/assets/images/logo/logo_woorao.png'),
    },
    // 山中靜靜
    {
      subdomain: 'immersion',
      branchId: config.public.BOOKING_ENGINE_BRANCH_ID_IMMERSION,
      logoImage: useAsset('@/assets/images/logo/logo_immersion.png'),
      headerLogoImage: useAsset('@/assets/images/logo/header_logo_immersion.png'),
    },
    // 霧語
    {
      subdomain: 'wooyuu',
      branchId: config.public.BOOKING_ENGINE_BRANCH_ID_WOOYUU,
      logoImage: useAsset('@/assets/images/logo/logo_wooyuu.svg'),
      headerLogoImage: useAsset('@/assets/images/logo/logo_wooyuu.svg'),
    },
    // 夕陽漫漫
    {
      subdomain: 'slowlysunset',
      branchId: config.public.BOOKING_ENGINE_BRANCH_ID_SLOWLYSUNSET,
      logoImage: useAsset('@/assets/images/logo/logo_slowlysunset.svg'),
      headerLogoImage: useAsset('@/assets/images/logo/logo_slowlysunset.svg'),
    },
    // 道 villa 湖畔莊園
    {
      subdomain: 'daovillalake',
      branchId: config.public.BOOKING_ENGINE_BRANCH_ID_DAOVILLALAKE,
      // logoImage: useAsset('@/assets/images/logo/logo_daovillalake.svg'),
      // headerLogoImage: useAsset('@/assets/images/logo/logo_daovillalake.svg'),
      logoImage: '',
      headerLogoImage: '',
    },
    // 蟬說 : 和社山林
    {
      subdomain: 'chanshuoforestville',
      branchId: config.public.BOOKING_ENGINE_BRANCH_ID_CHANSHUOFORESTVILLE,
      logoImage: useAsset('@/assets/images/logo/logo_chanshuoforestville.svg'),
      headerLogoImage: useAsset('@/assets/images/logo/logo_chanshuoforestville.svg'),
    },
    // 藍鵲菲菲
    {
      subdomain: 'chilllifestyle',
      branchId: config.public.BOOKING_ENGINE_BRANCH_ID_CHILLLIFESTYLE,
      logoImage: useAsset('@/assets/images/logo/logo_chilllifestyle.svg'),
      headerLogoImage: useAsset('@/assets/images/logo/logo_chilllifestyle.svg'),
    },
  ])

  const bookingData = computed(
    () => bookingEngineDataMap.find(data => data.subdomain === subdomainQS.value || data.subdomain === store.state?.tenantName) || {}
  )

  return {
    bookingData,
  }
}

export const useBookingEngine = () => {
  const { $store: store } = useNuxtApp()
  const route = useRoute()
  const subdomainQueryString = computed(() => route.query.subdomain)
  const { bookingData } = useBookingEngineData(subdomainQueryString, store)

  const bookingEngineCtx = reactive({
    isBookingEngine: computed(() => !!store.getters.isBookingEngine),
    logoImage: computed(() => (store.getters.isBookingEngine ? bookingData.value.logoImage : store.state.funnowLogoImage)),
    headerLogoImage: computed(() => (store.getters.isBookingEngine ? bookingData.value.headerLogoImage : store.state.funnowLogoImage)),
  })

  return {
    ...toRefs(bookingEngineCtx),
    data: bookingData,
  }
}

export const useBookingEngineOrderFn = (_orderId = '') => {
  const orderId = isRef(_orderId) ? _orderId : ref(_orderId)

  const { $axios } = useNuxtApp()
  const route = useRoute()
  const router = useRouter()
  const orderDetail = ref({})

  async function determineBookingEngineByOrder() {
    const result = await getOrderSource($axios, { orderID: orderId.value })
    orderDetail.value = result
    redirectWithOrder(orderDetail.value)
  }

  function redirectWithOrder(orderDetail) {
    if (!orderDetail) {
      return
    }
    const domainPrefix = orderDetail && orderDetail.domain_prefix
    const query = { ...route.query, subdomain: domainPrefix }
    const searchParams = new URLSearchParams(query)
    if (orderDetail && +orderDetail.source !== OrderSource.BookingEngine) {
      searchParams.delete('subdomain')
    }
    console.log('query: ', query)
    router.replace({ path: route.path, query: Object.fromEntries(searchParams.entries()) }).catch(e => e)
  }

  return {
    toLocation: determineBookingEngineByOrder,
  }
}
